// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__36tui","title":"InfoRow_title__2Earu"};